export interface UTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

const UTM_STORAGE_KEY = 'utm_params';

export const extractUTMFromURL = (
  searchParams?: URLSearchParams,
): UTMParams => {
  if (typeof window === 'undefined') return {};

  const urlParams = searchParams || new URLSearchParams(window.location.search);
  const utmParams: UTMParams = {};

  const utmSource = urlParams.get('utm_source');
  const utmMedium = urlParams.get('utm_medium');
  const utmCampaign = urlParams.get('utm_campaign');

  if (utmSource) utmParams.utm_source = utmSource;
  if (utmMedium) utmParams.utm_medium = utmMedium;
  if (utmCampaign) utmParams.utm_campaign = utmCampaign;

  return utmParams;
};

export const saveUTMParams = (utmParams: UTMParams): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParams));
  } catch (error) {}
};

export const getSavedUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') return {};

  try {
    const saved = localStorage.getItem(UTM_STORAGE_KEY);
    return saved ? JSON.parse(saved) : {};
  } catch (error) {
    return {};
  }
};

export const clearUTMParams = (): void => {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(UTM_STORAGE_KEY);
  } catch (error) {}
};

export const initializeUTMParams = (): UTMParams => {
  const currentUTM = extractUTMFromURL();
  const savedUTM = getSavedUTMParams();

  if (Object.keys(currentUTM).length > 0) {
    saveUTMParams(currentUTM);

    return currentUTM;
  }

  return savedUTM;
};
